import $ from 'jquery';
import WOW from 'wow.js';

export default class Animate {
    constructor() {
        if($('.wow').length) {
            const wow = new WOW({
                animateClass: 'animate__animated',
            });

            wow.init();
        };
    };
};
